// Which saved offline files the clean-up removes (used by tidyOfflineFiles in offline-db.ts). Plain function, no storage,
// so the rule can be tested on its own.
//
// Rules (unchanged from before, plus "protected"):
//  - a file not used for more than maxAgeMs is removed;
//  - the rest are kept most recently used first until budgetBytes is full, the others are removed;
//  - a PROTECTED file (a document of a transport unit the person pinned with "Keep offline") is never removed, by age or
//    by budget. Its size still counts against the budget, so it can crowd out other files but is never crowded out itself.

export interface TidyFile {
  key: string;
  size: number;
  /** Last time the file was opened or saved (epoch millis). */
  lastUse: number;
}

export interface TidyOptions {
  now: number;
  maxAgeMs: number;
  budgetBytes: number;
  protectedKeys?: ReadonlySet<string>;
}

export function selectFilesToRemove(files: readonly TidyFile[], opts: TidyOptions): { remove: string[]; keptBytes: number } {
  const remove: string[] = [];
  let bytes = 0;
  const loose: TidyFile[] = [];
  for (const f of files) {
    if (opts.protectedKeys?.has(f.key)) bytes += f.size;
    else loose.push(f);
  }
  const fresh = loose.filter((f) => {
    if (opts.now - f.lastUse > opts.maxAgeMs) {
      remove.push(f.key);
      return false;
    }
    return true;
  }).sort((a, b) => b.lastUse - a.lastUse); // most recently used first
  for (const f of fresh) {
    if (bytes + f.size > opts.budgetBytes) remove.push(f.key);
    else bytes += f.size;
  }
  return { remove, keptBytes: bytes };
}
